import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, checkp, formatDate, dayjsDate, formatDate2 } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import renderFileList from "../../components/renderFileList";
import ImgUploader from "../../components/ImgUploader";
import CustModal from "../../components/ShowModal";

const { Option } = Select;
function ZlkManager() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [cols, setCols] = useState([]);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [titles, setTitles] = useState({});
    const [editingRecord, setEditingRecord] = useState(null);
    const [canEdit, setCanEdit] = useState(false);
    const loadingRef = useRef();
    useEffect(() => {
        setCurrentPage(1);
        setFilters({});
        setfreshData(Math.random());
        let mcolumns = [];
        const reftitle = {};
        let canmod = false;
        switch (type) {
            case '1':
                canmod = checkp('sbzmwjm');
                setCanEdit(canmod);
                mcolumns = [
                    {
                        title: '序号',
                        dataIndex: 'sn',
                        key: 'sn',
                        width: 80,
                        fixed: 'left',
                        render: (text, record, rowIndex) => {
                            return rowIndex + 1 + (currentPage - 1) * pageSize;
                        },
                    },
                    { title: '月份', dataIndex: 'name', key: 'name' },
                    { title: '附件', dataIndex: 'files', key: 'files', render: (v) => renderFileList(v) },
                    { title: '备注', dataIndex: 'ps', key: 'ps' },
                    canmod && {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        render: (_, record) => (
                            <Space size="middle">
                                <Button
                                    type="link"
                                    icon={<EditOutlined />}
                                    onClick={() => showModal(record)}
                                >
                                    修改
                                </Button>
                                <Button
                                    type="link"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleDelete(record.id)}
                                >
                                    删除
                                </Button>
                            </Space>
                        ),
                    },
                ].filter(Boolean);
                break;
            case '2':
                canmod = checkp(['ryzsm']);
                setCanEdit(canmod);
                mcolumns = [
                    {
                        title: '序号',
                        dataIndex: 'sn',
                        key: 'sn',
                        width: 80,
                        fixed: 'left',
                        render: (text, record, rowIndex) => {
                            return rowIndex + 1 + (currentPage - 1) * pageSize;
                        },
                    },
                    { title: '月份', dataIndex: 'name', key: 'name' },
                    { title: '类型', dataIndex: 'ps1' },
                    { title: '授誉单位名称', dataIndex: 'ps2' },
                    { title: '荣誉名称', dataIndex: 'ps3' },
                    { title: '证书附件', dataIndex: 'files', key: 'files', render: (v) => renderFileList(v) },
                    { title: '备注', dataIndex: 'ps', key: 'ps' },
                    canmod && {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        render: (_, record) => (
                            <Space size="middle">
                                <Button
                                    type="link"
                                    icon={<EditOutlined />}
                                    onClick={() => showModal(record)}
                                >
                                    修改
                                </Button>
                                <Button
                                    type="link"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleDelete(record.id)}
                                >
                                    删除
                                </Button>
                            </Space>
                        ),
                    },
                ].filter(Boolean);
                break;
        }
        setCols(mcolumns);
        setTitles(prev => { return { ...prev, ...reftitle } });
    }, [type])
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { type, page: currentPage, limit: pageSize, ...filters };
                webPost('zlkList', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData]);



    const showModal = (record = null) => {
        setEditingRecord(record);
        if (record) {
            const item = {
                ...record, name: dayjsDate(record.name)
            }
            form.setFieldsValue(item);
        } else {
            form.resetFields();
        }
        setModalVisible(true);
    };
    const handleOk = async () => {
        try {
            if (loadingRef.current) return;
            loadingRef.current = true;
            const values = await form.validateFields();
            const payload = {
                ...values, id: editingRecord?.id || 0, type, name: formatDate2(values.name).substring(0, 7)
            };

            const res = await webPost('zlkSave', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        } finally{
            loadingRef.current = false;
        }
    };

    // 删除记录
    const handleDelete = async (id) => {
        Modal.confirm({
            title: '确认删除？',
            content: '此操作不可恢复',
            onOk: async () => {
                const res = await webPost('zlkDel', { id, type });
                if (res) {
                    message.success('删除成功');
                    saveSuccess();
                } else {
                    message.error('删除失败');
                }
            },
        });
    };
    const handleModalClose = () => {
        setModalVisible(false);
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    return (
        <FullHeightLayout
            headerContent={
                <Space style={{ 'display': 'flex', 'width': '100%' }}>
                    <Input value={filters?.mc} placeholder='月份' onChange={(e) => { setFilters(prev => ({ ...prev, mc: e.target.value })) }} />
                    <div style={{ 'flex': 1 }}></div>
                    {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
                        {type === '1' ? '新建社保证明' : '新建荣誉证书'}
                    </Button>}
                </Space>}
            bodyContent={
                <>
                    <Table
                        columns={cols}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 'max-content',
                            y: 'calc(100% - 20px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal
                        title={editingRecord ? '编辑' : '新建'}
                        open={modalVisible}
                        onOk={handleOk}
                        onCancel={() => setModalVisible(false)}
                        okText="保存"
                        cancelText="取消"
                        width={700}
                    >
                        <Form form={form} layout="vertical">
                            <Form.Item
                                name="name"
                                label="月份"
                            >
                                <DatePicker.MonthPicker format="YYYY-MM" />
                            </Form.Item>
                            {['2'].includes(type) && (<Form.Item name="ps1" label="类型"><Input /></Form.Item>)}
                            {['2'].includes(type) && (<Form.Item name="ps2" label="授誉单位名称"><Input /></Form.Item>)}
                            {['2'].includes(type) && (<Form.Item name="ps3" label="荣誉名称"><Input /></Form.Item>)}
                            <Form.Item
                                name="files"
                                label="附件"
                            >
                                <ImgUploader />
                            </Form.Item>
                            <Form.Item name="ps" label="备注">
                                <Input.TextArea />
                            </Form.Item>
                        </Form>
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default ZlkManager;
